/**
 * 页面类型
 */
export enum PAGE_TYPE {
  drawing = 0, // 绘制
  home = 1, // 首页
  enclosure = 2, //圈地
  rent = 3, // 出租
  edit = 4, // 编辑
  rentFirstShowList = 5, // 出租赚钱拉起列表
  weather = 6, // 天气预报
  planting = 7, // 我的种养
}
